module.exports = __webpack_public_path__ + "img/200706_homeLoading.f405a1f2.png";